import React from "react";
import "./MyEximContactDetails.css";
import { MailOutlined, PhoneOutlined, WhatsAppOutlined } from "@ant-design/icons";

const MyEximContactDetails = () => {
  const businessData = {
    name: "MY EXIM BUSINESS",
    registeredName: "Thaswikha Exim Services Private Limited",
    address: [
      "Sreevari Enclave, Ground Floor",
      "Plot no:226, Door No: 8/8,",
      "Elango Street, Alwarthirunagar,",
      "Chennai, Tamil Nadu,",
      "India - 600087",
    ],
    phone: "+91 99944 07890",
    email: "contactus@myeximbusiness.com",
  };

  return (
    <div className="contact-container">
      <div className="background-pattern"></div>
      <div className="wrapper">
        <div className="hero-section">
          <div className="hero-content">
            <h1 className="title">{businessData.name}</h1>
            <p className="sub-title">{businessData.registeredName}</p>
          </div>
        </div>

        <div className="grid-container">
          <div className="card">
            <div className="card-header">
              <div className="icon-container">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/>
                </svg>
              </div>
              <h3 className="card-title">Visit Us</h3>
            </div>
            <div className="address-content">
              {businessData.address.map((line, i) => (
                <p key={i} className="address-line">
                  {line}
                </p>
              ))}
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="icon-container">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="currentColor"/>
                </svg>
              </div>
              <h3 className="card-title">Contact Us</h3>
            </div>
            
            <div className="contact-list">
              <div className="contact-item">
                <span className="contact-icon"> <PhoneOutlined /></span>
                <div className="contact-info">
                  <span className="contact-label">Phone</span>
                  <a href={`tel:${businessData.phone}`} className="contact-link">
                    {businessData.phone}
                  </a>
                </div>
              </div>

              <div className="contact-item">
                <span className="contact-icon"><MailOutlined /></span>
                <div className="contact-info">
                  <span className="contact-label">Email</span>
                  <a href={`mailto:${businessData.email}`} className="contact-link">
                    {businessData.email}
                  </a>
                </div>
              </div>

              <div className="contact-item">
                <span className="contact-icon"><WhatsAppOutlined style={{ color: '#25D366' }} /></span>
                <div className="contact-info">
                  <span className="contact-label">WhatsApp</span>
                  <a
                    href={`https://wa.me/${businessData.phone.replace(/\D/g, "")}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-link whatsapp-link"
                  >
                    Chat with us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="action-buttons">
          <a href={`mailto:${businessData.email}`} className="action-button-primary">
            Send Email
          </a>
          <a 
            href={`https://wa.me/${businessData.phone.replace(/\D/g, "")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="action-button-secondary"
          >
            WhatsApp Now
          </a>
        </div>
      </div>
    </div>
  );
};

export default MyEximContactDetails;